import axios from "axios";

// 運行情報取得
export const fetchRailWayStatus = async () => {
  const url =
    "https://x3ftuj0g1k.execute-api.ap-northeast-1.amazonaws.com/production/api/v2/odakyu-railway/status";
  const headers = {
    "x-api-key": "aJNU1bXZ0h4GzoijC3lSN1Md31emv0iC36jTENpS",
  };
  const client = axios.create({
    baseURL: url,
    headers,
  });

  const resp = await client.get();
  return resp.data;
};
